import Cookies from 'js-cookie';

/** Product verticals — UI lens labels (sent as `vertical` query param to BE). */
export const VERTICAL_OPTIONS = [
  { id: 'sales', label: 'Sales' },
  { id: 'management', label: 'Management' },
  { id: 'operations', label: 'Operations' },
  { id: 'inventory', label: 'Inventory' },
  { id: 'marketing', label: 'Marketing' },
  { id: 'accounts', label: 'Accounts' }
];

const VERTICAL_ID_BY_COOKIE = {
  sales: 'sales',
  management: 'management',
  operations: 'operations',
  inventory: 'inventory',
  marketing: 'marketing',
  accounts: 'accounts'
};

/** Builder business owner (primary account), not the "builder" perspective tab. */
export function isBuilderAccountOwner() {
  const role = String(Cookies.get('userRole') || '').toLowerCase();
  const vertical = String(Cookies.get('userVertical') || '').toLowerCase();
  const level = Cookies.get('userDesignationLevel');
  return role === 'builder' && vertical === 'management' && level === 'High';
}

export function getUserVerticalId() {
  const raw = String(Cookies.get('userVertical') || '').toLowerCase();
  return VERTICAL_ID_BY_COOKIE[raw] || 'sales';
}

export function resolveAllowedVerticals(
  isBuilder = isBuilderAccountOwner(),
  { fixedVertical = null } = {},
) {
  if (fixedVertical) {
    const match = VERTICAL_OPTIONS.find((o) => o.id === fixedVertical);
    return match ? [match] : [VERTICAL_OPTIONS[0]];
  }
  if (isBuilder) return VERTICAL_OPTIONS;
  const match = VERTICAL_OPTIONS.find((o) => o.id === getUserVerticalId());
  return match ? [match] : [VERTICAL_OPTIONS[0]];
}

export function resolveDefaultVertical(defaultVertical, isBuilder = isBuilderAccountOwner()) {
  if (defaultVertical) return defaultVertical;
  if (isBuilder) return 'sales';
  return getUserVerticalId();
}

/**
 * @deprecated Phase B uses `vertical` query param directly. Kept for any legacy callers.
 */
export function verticalToApiPerspective(
  verticalId,
  { allProjects = false, isBuilder = isBuilderAccountOwner() } = {}
) {
  const level = Cookies.get('userDesignationLevel');

  if (!isBuilder) {
    const userVertical = getUserVerticalId();
    if (userVertical === 'management') {
      if (level === 'High') return allProjects ? 'admin' : 'management';
      return 'management';
    }
    if (level === 'High') return allProjects ? 'admin' : 'builder';
    if (level === 'Medium') return 'manager';
    return 'executive';
  }

  switch (verticalId) {
    case 'management':
      return allProjects ? 'admin' : 'management';
    case 'operations':
      return 'executive';
    case 'inventory':
      return 'builder';
    case 'marketing':
      return 'executive';
    case 'accounts':
      return 'admin';
    case 'sales':
    default:
      return allProjects ? 'admin' : 'builder';
  }
}
